<template>
<div class="chapter">
<div class="inner_page">
<p class="line" id="blueline1"><img alt="image" src="Images/blueline.jpg"/></p>
<p class="tx">Whenever yet another white person murders a black person on video and doesn’t even get in trouble, the first thing you ask me is, <i>Why are you so angry?</i> Keep that to yourself, or say what you mean: <i>How did you notice that we are killing you?</i></p>
<p class="line" id="blueline2"><img alt="image" src="Images/blueline.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap4.vue?e330870c